var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#479a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.948 9.422-1.16-1.367c-.314-.364-.648-.586-.995-.232l-.695.663c-.535.597-.963.378-1.443-.013L4.045 5.24c-.315-.364-.346-.808.001-1.162l.962-.962c.348-.355.158-.736-.157-1.1L3.2.254c-.316-.365-.722-.321-1.07.033C1.44.997.952 1.871.794 2.947c-.193 1.313.269 2.986 1.02 3.863.228.267 2.669 3.302 3.285 4.004.827.94 2.102 1.293 3.323 1.158 1-.11 1.923-.713 2.62-1.422.347-.353.222-.763-.094-1.128",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "479a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgOldPhoneFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOldPhoneFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8yNDQ5KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuOTQ3NSA5LjQyMjI4TDkuNzg4NzYgOC4wNTUwNEM5LjQ3Mzc3IDcuNjkwNTUgOS4xNDAwMiA3LjQ2ODU1IDguNzkyNzcgNy44MjI1NUw4LjA5NzUzIDguNDg1NTRDNy41NjI3OCA5LjA4MzI5IDcuMTM1MjkgOC44NjQyOSA2LjY1NTI5IDguNDcyNzlMNC4wNDQ1NyA1LjI0MTA3QzMuNzI5NTcgNC44NzczMiAzLjY5ODgyIDQuNDMyNTggNC4wNDYwNyA0LjA3ODU4TDUuMDA4MzEgMy4xMTcwOUM1LjM1NjMgMi43NjIzNCA1LjE2NTgxIDIuMzgwNiA0Ljg1MDgxIDIuMDE2ODVMMy4yMDAwNyAwLjI1MzYxN0MyLjg4NTA4IC0wLjExMDg3OSAyLjQ3ODU4IC0wLjA2NzM3OTcgMi4xMzEzMyAwLjI4NzM2N0MxLjQzOTA5IDAuOTk3NjEgMC45NTIzNDQgMS44NzA2IDAuNzk0MDk2IDIuOTQ3NTlDMC42MDA1OTggNC4yNjAwOCAxLjA2MjU5IDUuOTMyNTYgMS44MTQwOSA2LjgxMDA2QzIuMDQyMDggNy4wNzcwNSA0LjQ4MjU2IDEwLjExMjMgNS4wOTkwNiAxMC44MTQzQzUuOTI2MyAxMS43NTQgNy4yMDEyOSAxMi4xMDczIDguNDIxNTMgMTEuOTcyM0M5LjQyMTI3IDExLjg2MTMgMTAuMzQ1MyAxMS4yNTkgMTEuMDQxMyAxMC41NTAzQzExLjM4ODUgMTAuMTk3IDExLjI2NCA5Ljc4Njc4IDEwLjk0ODMgOS40MjIyOCIgZmlsbD0iY3VycmVudENvbG9yIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjcxXzI0NDkiPgo8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";